import * as ko from "knockout";
import {observable} from "knockout-decorators";
import {ModalBodyComponentContext} from "../modal/modal";
import {IdeaDto} from "../../../api/generated";
import i18nextko from "../../../bindings/i18nko";
import {ideaStateOptions} from "../../../pages/ideas/ideaUtils";


interface IdeaStateUpdateViewModelParams extends ModalBodyComponentContext {
    params: {
        idea: IdeaDto;
        selectedState: IdeaDto.StateEnum;
        infoText: string;
    };
}
class IdeaStateUpdateViewModel {

    @observable({deep: true, expose: true})
    public idea: IdeaDto;

    @observable({deep: false, expose: true})
    public selectedState: IdeaDto.StateEnum;

    @observable({deep: false, expose: true})
    public published: boolean;

    @observable({deep: false, expose: false})
    public infoText: string;

    constructor(ctx: IdeaStateUpdateViewModelParams) {
        this.idea = ctx.params.idea;
        this.selectedState = ctx.params.selectedState || null;
        this.published = this.idea.published;
        this.infoText = ctx.params.infoText || null;

        ctx.callback.getResolveData = () => {
            console.log("callback.getResolveData")
            this.idea.state = this.selectedState;
            if (this.published && !this.idea.published) {
                this.idea.published = this.published;
            }
            return Promise.resolve();
        }
    }

    /**
     * Get the options for the idea state.
     */
    public ideaStateOptions() {
        return ideaStateOptions();
    }

    public i18n(key: String, options?: object) {
        return i18nextko.t(key, options);
    }

}

const component:KnockoutComponentTypes.Config = {
    viewModel: (params: IdeaStateUpdateViewModelParams) => new IdeaStateUpdateViewModel(params),
    template: <string>require('./idea-state-update-modal.html')
};

if (!ko.components.isRegistered('idea-state-update-modal')) {
    ko.components.register('idea-state-update-modal', component)
}
